module.exports = __webpack_public_path__ + "static/img/p7.f299be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p7.png
// module id = oE94
// module chunks = 0